/* Top ~30 countries supported by MSG91, India default. */
export const COUNTRIES = [
  { code: "IN", name: "India",                dial: "+91", flag: "🇮🇳", aliases: ["bharat"] },
  { code: "US", name: "United States",        dial: "+1",  flag: "🇺🇸", aliases: ["usa", "america"] },
  { code: "GB", name: "United Kingdom",       dial: "+44", flag: "🇬🇧", aliases: ["uk", "britain", "england"] },
  { code: "AE", name: "United Arab Emirates", dial: "+971",flag: "🇦🇪", aliases: ["uae", "dubai", "abu dhabi"] },
  { code: "SG", name: "Singapore",            dial: "+65", flag: "🇸🇬" },
  { code: "AU", name: "Australia",            dial: "+61", flag: "🇦🇺" },
  { code: "CA", name: "Canada",               dial: "+1",  flag: "🇨🇦" },
  { code: "SA", name: "Saudi Arabia",         dial: "+966",flag: "🇸🇦", aliases: ["ksa"] },
  { code: "DE", name: "Germany",              dial: "+49", flag: "🇩🇪" },
  { code: "FR", name: "France",               dial: "+33", flag: "🇫🇷" },
  { code: "JP", name: "Japan",                dial: "+81", flag: "🇯🇵" },
  { code: "BR", name: "Brazil",               dial: "+55", flag: "🇧🇷" },
  { code: "MX", name: "Mexico",               dial: "+52", flag: "🇲🇽" },
  { code: "ID", name: "Indonesia",            dial: "+62", flag: "🇮🇩" },
  { code: "BD", name: "Bangladesh",           dial: "+880",flag: "🇧🇩" },
  { code: "PK", name: "Pakistan",             dial: "+92", flag: "🇵🇰" },
  { code: "LK", name: "Sri Lanka",            dial: "+94", flag: "🇱🇰" },
  { code: "NP", name: "Nepal",                dial: "+977",flag: "🇳🇵" },
  { code: "MY", name: "Malaysia",             dial: "+60", flag: "🇲🇾" },
  { code: "TH", name: "Thailand",             dial: "+66", flag: "🇹🇭" },
  { code: "PH", name: "Philippines",          dial: "+63", flag: "🇵🇭" },
  { code: "ZA", name: "South Africa",         dial: "+27", flag: "🇿🇦" },
  { code: "NG", name: "Nigeria",              dial: "+234",flag: "🇳🇬" },
  { code: "KE", name: "Kenya",                dial: "+254",flag: "🇰🇪" },
  { code: "EG", name: "Egypt",                dial: "+20", flag: "🇪🇬" },
  { code: "TR", name: "Turkey",               dial: "+90", flag: "🇹🇷" },
  { code: "IT", name: "Italy",                dial: "+39", flag: "🇮🇹" },
  { code: "ES", name: "Spain",                dial: "+34", flag: "🇪🇸" },
  { code: "NL", name: "Netherlands",          dial: "+31", flag: "🇳🇱", aliases: ["holland"] },
  { code: "QA", name: "Qatar",                dial: "+974",flag: "🇶🇦" },
];

export const DEFAULT_COUNTRY = COUNTRIES[0];
